import React from 'react';
import { XIcon, ClockIcon } from 'lucide-react';
const NOT_THIS = ['No se trata de acumular ideas de contenido.', 'No se trata de bailar frente a una cámara.', 'No se trata de publicar tres veces por día.', 'No se trata de convertirte en influencer.'];
export function DifferentiationSection() {
  return <section className="bg-cream py-12 sm:py-16" data-id="element-43" data-mp="acf7ifsuhoog">
      <div className="mx-auto max-w-4xl px-5" data-id="element-44" data-mp="5edsc5yji9i9">
        <div className="text-center" data-id="element-45" data-mp="5ff6wkerle4q">
          <h2 className="font-display text-2xl font-black leading-tight text-ink sm:text-4xl" data-id="element-46" data-mp="5caux0v25e3i">
            No necesitás otra lista de 100 ideas para Instagram.
          </h2>
        </div>

        <ul className="mx-auto mt-7 grid max-w-2xl gap-2.5" data-id="element-47" data-mp="3rlvhge3wvrbj">
          {NOT_THIS.map(n => <li key={n} className="flex items-start gap-2.5 text-sm leading-snug text-ink/70" data-id="element-48" data-mp="3nltfe3u9kvvq">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-rose/10" data-id="element-49" data-mp="1ptfpjs7qs14u">
                <XIcon className="h-3.5 w-3.5 text-rose-deep" aria-hidden data-id="element-50" data-mp="1lqsulifry03f" />
              </span>
              {n}
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-2xl text-center text-sm leading-relaxed text-ink/75 sm:text-base" data-id="element-51" data-mp="t2kdfqzi6p0z">
          Se trata de entender qué comunicar, cómo comunicarlo y cómo transformar la atención en
          oportunidades reales para tu estética.
        </p>

        <div className="mx-auto mt-9 max-w-2xl rounded-3xl border border-rose/10 bg-white p-5 shadow-sm sm:p-6" data-id="element-52" data-mp="16t7gfvcar12v">
          <div className="flex items-start gap-3" data-id="element-53" data-mp="1bsk3ag36485g">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blush" data-id="element-54" data-mp="1bu4upwu6raz3">
              <ClockIcon className="h-5 w-5 text-rose" aria-hidden data-id="element-55" data-mp="xyj7nv7ij19b" />
            </span>
            <div data-id="element-56" data-mp="120ecvaskdysd">
              <h3 className="font-display text-lg font-bold text-ink" data-id="element-57" data-mp="11zus7mbj4wan">
                Está pensado para profesionales de estética, no para especialistas en marketing.
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-58" data-mp="1ukmmnz7722je">
                No necesitás estudiar marketing durante meses ni pasar horas frente a Instagram. El
                sistema está diseñado para que encuentres rápido lo que necesitás y puedas aplicarlo
                a tu negocio.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}